export enum StatoGiudizio {
    todo = "TODO",
    done = "DONE",
    expired = "EXPIRED"
}
